import React from "react";


export default function Footer() {
    return (
        <footer className="footer">
            <p>© {new Date().getFullYear()} RO Service Patna. All rights reserved. | Designed & Developed by{" "}
                <a style={{color:'#fff',cursor:'pointer'}} href="https://wappotix.com/" target="_blank" rel="noopener noreferrer">Wappotix Private Limited</a>
            </p>
        </footer>
    );
}